import { Head } from "@inertiajs/react"
import { Container, Heading, Section } from "@radix-ui/themes"
import StatsGrid from "@/shared/admin/StatsGrid"
import { AdminStats } from "@/types/shared"

interface Props {
  stats: AdminStats
}

export default function AdminIndex({ stats }: Props) {
  return (
    <div className="flex">
      <Head title="Admin" />
      <div className="grow">
        <Section>
          <Container size="4">
            <Heading size="7" mb="6">
              Admin Dashboard
            </Heading>
            <StatsGrid stats={stats} />
          </Container>
        </Section>
      </div>
    </div>
  )
}
